<template>
  <div class="ali-player">
    <div class="video-box">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :options="playerOptions"
        @ready="onPlayerReadied"
        @error="onError($event)"
        @pause="onPause"
        @play="onPlay"
        @timeupdate="onTimeupdate"
        @loadeddata="onPlayerLoadeddata"
        @statechanged="playerStateChanged($event)"
      >
      </video-player>
      <div v-if="!loading" class="control-box">
        <!-- 进度条 -->
        <div class="video-progress" v-if="isProgress">
          <el-slider
            v-model="sliderTime"
            :format-tooltip="formatProcessToolTip"
            @change="changeCurrentTime"
            class="slider"
          ></el-slider>
        </div>
        <!-- 时移标尺 -->
        <div class="shift-scaleLine" v-if="shift">
          <div id="date_list_player" v-if="openData">
            <div class="program-list" 
            v-for="(item,index) in program"
            :key="index"
            @click="getDatePro(item,index)"
            :class="proIndex==index?'is-active':''">
              <div
                v-if="index<program.length-1"
              >{{item.week}}</div>
              <div v-else >{{item.week}}</div>
            </div>
          </div>
          <div class="date-select">
              <!-- 日期 -->
            <div class="program-list" 
              @click="openData = !openData">
              <div>{{newDate.week}}</div>
              <div>{{newDate.date}}</div>
            </div>
          </div>
          <div class="date-scale">
              <!-- 时间节点 -->
              <div id="timeshift_scale_player" @click="getPointerNode">
                <div class="timeshift-scale-list" ref="scalePlayer">
                   <div class="scale-10-minute" v-for="item in timeNode" :key="item">
                    <span class="scale-10-node">{{item}}</span>
                    <div class="scale-1-minute" v-for="res in 4" :key="res"></div>
                   </div>
                </div>
              </div>
              <!-- 节目列表 -->
              <div id="timeshift_epg_player">
                <div class="epg-left-button epg-button" @click="leftClick">
                  <img
                   class="left-no-mous epg-player-btn first-epg"
                  src="@/assets/ckVideo/epg_left.png">
                  <img 
                  class="left-mous epg-player-btn second-epg"
                  src="@/assets/ckVideo/epg_left_mouseover.png">
                </div>
                <div class="epg-program" ref="epgPlayer"></div>
                <div class="epg-right-button epg-button" @click="rightClick">
                  <img
                  class="right-no-mous epg-player-btn first-epg"
                  src="@/assets/ckVideo/epg_right.png"
                  >
                  <img
                    class="right-mous epg-player-btn second-epg"
                    src="@/assets/ckVideo/epg_right_mouseover.png"
                  >
                </div>
              </div>
              <!-- 操作节点 -->
              <div
                id="timeshift_pointer_player"
                ref="pointer"
                @mousedown="getPointer"  style="left: 300PX;">
                <img
                  src="@/assets/ckVideo/epg_pointer.png"
                  style="width:20PX;height:70PX;">
              </div>
          </div>
        </div>
        <!-- 播放控件 -->
        <div class="video-control">
          <div class="control-left">
            <div class="video-btn">
              <div
                v-if="!this.video.playing"
                @click="play"
              ><img :src="require('@/assets/img/playerimg/palying.png')" title="播放"/></div>
              <div
                v-else
                @click="pause"
              ><img :src="require('@/assets/img/playerimg/pause.png')" title="暂停"/></div>
            </div>
            <p class="video-time">
              <span>{{realFormatSecond(this.video.currentTime)}}</span>
              <!-- <span>{{videoInfo.time}}</span> -->
            </p>
          </div>
          <div class="control-right">
            <!-- 时移 -->
            <div class="time-shift" v-if="showShift">
              <span class="title">时移:</span>
              <el-switch 
                v-model="shift">
              </el-switch>
            </div>
            <!-- 分辨率 -->
            <div class="ratio" v-if="sourceListUrl">
              <el-popover
               placement="top"
               popper-class="ratio-popover"
               :visible-arrow="true"
               trigger="hover">
                <ul class="ratio-list">
                  <li  v-for="(item,index) in sourceListUrl" :key="index"
                    :class="index==ratioIndex?'is-active':''"
                    @click="setRatio(item,index)">
                    {{item.resolutionName}}
                  </li>
                </ul>
                <div class="news-ratio" slot="reference">{{newRatio.resolutionName}}</div>
              </el-popover>
            </div>
            <!-- 音量 -->
            <div class="video-sound" >
              <div
                id="player_sound_btn_player"
                volume="50"
                ismute="false"
                @click="showSound">
                <img
                  v-if="!sound"
                  id="player_sound_yes_player"
                  src="@/assets/img/playerimg/sound.png"
                >
                <img
                  v-if="sound"
                  id="player_sound_no_player"
                  src="@/assets/img/playerimg/sound-no.png"
                >
              </div>
              <el-slider
                class="sound-slider"
                vertical
                style="height:100PX;cursor:pointer; width: 10PX;"
                v-model="soundValue"
                @change="getChange"
                :style="{ 'opacity': soundOpacity,'display':!!soundOpacity?'block':'none'}"
              ></el-slider>
            </div>
            <!-- 画中画 -->
            <!-- <div class="pictureInPicture" @click="openPicInpic"  @mouseenter="InPicture=true"
                @mouseleave="InPicture=false">
              <img v-if="inpic==true&& !InPicture" :src="require('@/assets/img/playerimg/outpic.png')" title="画中画"/>
              <img v-if="inpic==true&& InPicture" :src="require('@/assets/img/playerimg/outpic.png')" title="画中画"/>
              <img v-if="inpic==false&& !InPicture" :src="require('@/assets/img/playerimg/picInpic.png')" title="画中画"/>
              <img v-if="inpic==false&& InPicture" :src="require('@/assets/img/playerimg/inpic.png')" title="画中画"/>
            </div> -->
            <!-- 全屏 -->
            <div class="full-screen" @click="openFullscreen" @mouseenter="InFullscreen=true"
                @mouseleave="InFullscreen=false">
              <img v-if="!InFullscreen" :src="require('@/assets/img/playerimg/fullscreen.png')" title="全屏"/>
               <img v-else :src="require('@/assets/img/playerimg/inFullscreen.png')" title="全屏"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
        v-if="loading"
        :style="{width:'100%',height:'100%',position:'absolute',left:'0PX',top:'0PX'}"
      >
        <img
          :style="{width:'100%',height:'100%'}"
          :src="require('@/assets/img/loding.gif')"
        />
      </div>
  </div>
</template>
<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import 'videojs-contrib-hls'
import axios from '@/utils/vlive.js'
export default {
  name: "",
  components: { videoPlayer },
  props: ['sourceUrl', "passagewayId",'sourceListUrl','timeShift','playTime','muted'],
  data () {
    return {
      soundOpacity:0,
      loading:false,
      isProgress:false,
      userid: '',
      urlId: '',
      timer:null,
      urlTimer:'',
      step: 0, // 左右按钮
      timeNode:[], // 时间列表
      newDate:{
        week:'',
        date:'',
      },
      openData:false,
      program:[], // 时间选择列
      proIndex: 6, // 列表标识
      showShift:false,
      shift:false,
      newRatio:{},
      ratioIndex:0,
      InPicture:false,
      InFullscreen:false,
      inpic:false, // 画中画false展示未进入状态,点击进入
      showMouse:false,
      followBtn:false,
      newSoundValue: 75,
      soundValue:75,
      sound:false,
      sliderTime: 0,
      video: {
        // 该字段是音频是否处于播放状态的属性
        playing: false,
        // 音频当前播放时长
        currentTime: 0,
        // 音频最大播放时长
        maxTime: 0,
      },
      audioDetail: {},
      videoInfo: {
        time: 0,
      },
      progressing_audio: 0,
      loading: true,
      playerOptions: {
        autoplay: false, //如果true,浏览器准备好时开始回放。(好像微信浏览器不太行)
        techOrder: ['html5'], // 需要加载的插件，如果是要兼容flash的话，必须先加载flash。顺序不能错：['flash','html5']
        flash: {
          hls: { withCredentials: false }
        },
        html5: { hls: { withCredentials: false } },
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        language: 'zh-CN', // 提示的语言 中文的话是 zh-CN
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度 0.7倍...
        sources: [
          {
            withCredentials: false, // 直播是否有播放令牌，反正我是没有
            type: "", // m3u8/Hls 的视频流类型
            src: "",
          },
        ],
        poster: '', //你的封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controls: false, // 是否显示操作条
        controlBar: {
          // 播放的操作
          timeDivider: false, // 时间分割线
          durationDisplay: false, // 总时间
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }
    };
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    },
    currentStream () {
      return this.currentTech === 'Flash' ? 'RTMP' : 'HLS'
    }
  },
  mounted () {
    if (this.sourceUrl) {
      var index = this.sourceUrl.lastIndexOf(".");
      var ext = this.sourceUrl.substr(index + 1);
      var ipos = ext.indexOf("?")||ext;//指定开始的字符串
      let str1 =ipos==-1?ext:ext.substring(0,ipos); //取前部分（指定开始的字符串的之前
     
      if(str1 == 'm3u8') {
        this.isProgress=false
        this.playerOptions.sources[0].type = 'application/x-mpegURL'
      }else if(ext == 'flv') {
        this.isProgress=false
        this.playerOptions.sources[0].type = 'video/x-flv'
      }else if(ext == 'mov') {
        this.isProgress=true
        this.playerOptions.sources[0].type = 'rtmp/mp4'
      }else{
        this.isProgress=true
        this.playerOptions.sources[0].type = 'video/mp4'
        // this.playerOptions.autoplay = false
      }
       this.playerOptions.sources[0].src = this.sourceUrl
    }
    if (this.sourceListUrl&&this.sourceListUrl.length>0) {
      this.newRatio = this.sourceListUrl[0]
      this.ratioIndex = 0
      var url = this.newRatio.resolutionPath
      var index = url.lastIndexOf(".");
      var ext = url.substr(index + 1);
      var ipos = ext.indexOf("?") || ext; //指定开始的字符串
      let str1 = ipos == -1 ? ext : ext.substring(0, ipos); //取前部分（指定开始的字符串的之前
      if (str1 == "m3u8") {
        this.isProgress=false
        this.playerOptions.sources[0].type = "application/x-mpegURL";
      } else if (ext == "flv") {
         this.isProgress=false
        this.playerOptions.sources[0].type = "video/x-flv";
      } else if (ext == "mov") {
        this.isProgress=true
        this.playerOptions.sources[0].type = "rtmp/mp4";
      } else {
        this.isProgress=true
        this.playerOptions.sources[0].type = "video/mp4";
      }
      this.playerOptions.sources[0].src = url
    }
    if (this.timeShift) {
      this.showShift = !!this.timeShift
      this.shift = !!this.timeShift
      this.isProgress=false
    }
    // 获取当前时间
    let hours = new Date().getHours()
    let minutes = new Date().getMinutes()
    if (this.playTime) {
      this.time = new Date(this.playTime).getHours() + new Date(this.playTime).getMinutes()
    }else{
      this.time = hours * 60 + minutes
    }
    if (this.shift) {
    this.$nextTick(() => {
      // this.$refs.epgWidth.style.width = parseInt(this.$refs.controlBbar.clientWidth) - 120 + 'PX'
      var boxWith = document.querySelector(".date-scale").clientWidth;
      this.pointerLeft = parseInt(this.$refs.pointer.style.left) + 10
      // this.$refs.epgPlayer.style.left = -this.time * 10 + this.pointerLeft + 'PX' // 当表单偏移量
      this.$refs.scalePlayer.style.left = -this.time * 10 + this.pointerLeft + 'PX' // 当时间偏移量
      this.newScalePlayer = -this.time * 10 + this.pointerLeft
      this.step = -parseInt((this.time * 10 + this.pointerLeft) / boxWith) + 1 // 当前步进值
      })
    }
    if (this.muted) {
      this.sound = false
      this.soundValue = 75
      this.player.cache_.lastVolume = 75
      this.player.volume(this.player.cache_.lastVolume)
      this.playerOptions.muted=false
      // this.playerOptions.muted=true
    }
  },
  watch: {
    passagewayId (newValue) {
      this.urlId = newValue
    },
    sourceUrl(newValue) {
      var index = this.sourceUrl.lastIndexOf(".");
      var ext = this.sourceUrl.substr(index + 1);
      var ipos = ext.indexOf("?") || ext; //指定开始的字符串
      let str1 = ipos == -1 ? ext : ext.substring(0, ipos); //取前部分（指定开始的字符串的之前
      if (str1 == "m3u8") {
        this.isProgress=false
        this.playerOptions.sources[0].type = "application/x-mpegURL";
      } else if (ext == "flv") {
        this.isProgress=false
        this.playerOptions.sources[0].type = "video/x-flv";
      } else if (ext == "mov") {
        this.isProgress=true
        this.playerOptions.sources[0].type = "rtmp/mp4";
      } else {
        this.isProgress=true
        this.playerOptions.sources[0].type = "video/mp4";
      }
      this.playerOptions.sources[0].src = newValue
    },
    sourceListUrl(newValue){
       this.newRatio = newValue[0]
       this.ratioIndex = 0
       var url = this.newRatio.resolutionPath
       var index = url.lastIndexOf(".");
       var ext = url.substr(index + 1);
       var ipos = ext.indexOf("?") || ext; //指定开始的字符串
       let str1 = ipos == -1 ? ext : ext.substring(0, ipos); //取前部分（指定开始的字符串的之前
       if (str1 == "m3u8") {
        this.isProgress=false
         this.playerOptions.sources[0].type = "application/x-mpegURL";
       } else if (ext == "flv") {
         this.isProgress=false
         this.playerOptions.sources[0].type = "video/x-flv";
       } else if (ext == "mov") {
         this.isProgress=true
         this.playerOptions.sources[0].type = "rtmp/mp4";
       } else {
         this.isProgress=true
         this.playerOptions.sources[0].type = "video/mp4";
       }
       this.playerOptions.sources[0].src = url
    },
    timeShift (newValue) {
      this.showShift = !!newValue
      this.shift = !!newValue
    },
    playTime (newValue) {
      if (this.shift) {
        let hours = new Date(newValue).getHours()
        let minutes = new Date(newValue).getMinutes()
        this.time = hours * 60 + minutes
        this.$nextTick(() => {
          this.pointerLeft = parseInt(this.$refs.pointer.style.left) - 10
          this.$refs.scalePlayer.style.left = -this.time * 10 + 60 + this.pointerLeft + 'PX' // 当时间偏移量
        })
      }
    }
  },
  methods: {
    //播放状态改变回调
    playerStateChanged (playerCurrentState) {
      if (playerCurrentState.playing) {
        this.loading = false
      } 
    },
    // 切换清晰度
    setRatio (item,index) {
      this.newRatio = item
      this.ratioIndex = index
      var url = item.resolutionPath
       var index = url.lastIndexOf(".");
       var ext = url.substr(index + 1);
       var ipos = ext.indexOf("?") || ext; //指定开始的字符串
       let str1 = ipos == -1 ? ext : ext.substring(0, ipos); //取前部分（指定开始的字符串的之前
       if (str1 == "m3u8") {
        this.isProgress=false
         this.playerOptions.sources[0].type = "application/x-mpegURL";
       } else if (ext == "flv") {
        this.isProgress=false
         this.playerOptions.sources[0].type = "video/x-flv";
       } else if (ext == "mov") {
        this.isProgress=true
         this.playerOptions.sources[0].type = "rtmp/mp4";
       } else {
        this.isProgress=true
         this.playerOptions.sources[0].type = "video/mp4";
       }
       this.playerOptions.sources[0].src = url
    },
    // 画中画
    openPicInpic () {
      let video = document.querySelector('.vjs-tech')
      var that = this
      video.addEventListener('enterpictureinpicture', function() {
         that.inpic=true
      });
      video.addEventListener('leavepictureinpicture', function() {
        that.inpic=false
      });
      if (video !== document.pictureInPictureElement) {
        this.player.requestPictureInPicture()
      }else{
        document.exitPictureInPicture();
      }
    },
    openFullscreen () {
      this.player.requestFullscreen()
    },
    onPlayerReadied () {
      if (!this.initialized) {
        this.initialized = true
        this.currentTech = this.player.techName_
      }
    },
    changeTech () {
      if (this.currentTech === 'Html5') {
        this.playerOptions.techOrder = ['html5']
      } else if (this.currentTech === 'Flash') {
        this.playerOptions.techOrder = ['flash']
      }
      this.playerOptions.autoplay = false
    },
    onError () {
      // this.$message.warning('播放错误!')
    },
    // 时间
    realFormatSecond(second) {
      var secondType = typeof second
      if (secondType === 'number' || secondType === 'string') {
        second = parseInt(second)
        var hours = Math.floor(second / 3600)
        second = second - hours * 3600
        var mimute = Math.floor(second / 60)
        second = second - mimute * 60
          return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
        // return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
      } else {
        return '00:00'
      }
    },

    // 播放
    play() {
      this.$refs.videoPlayer.player.play();
      this.timer = setInterval(() => {
        this.progressing_audio =
          (this.progressing_audio / 100 + 0.1 / this.video.maxTime) * 100;
        this.second = this.second + 0.1;
        if (this.progressing_audio >= 100) {
          clearInterval(this.timer);
          this.progressing_audio = 0;
          this.second = 0;
        }
      }, 100);
    },
    // 暂停
    pause() {
      this.$refs.videoPlayer.player.pause();
      clearInterval(this.timer)
    },
    // 当播放
    onPlay() {
      this.video.playing = true;
      if (this.shift) {
        this.createdNode()
      }
      if (this.showShift) {
        clearInterval(this.urlTimer);
        this.urlTimer = null
        this.createdUrl()
      }
      
    },
    // 当暂停
    onPause() {
      this.video.playing = false;
      // this.disNode()
      clearInterval(this.urlTimer);
      this.urlTimer = null
      // this.getHeartbeat(1)
    },
    // 进度条toolTip
    formatProcessToolTip(index) {
      index = parseInt(this.video.maxTime / 100 * index)
      return '进度条: ' + this.realFormatSecond(index)
    },
    // 播放跳转
    changeCurrentTime(index) {
    //  this.player.cache_.currentTime = parseInt(index / 100 * this.video.maxTime)
      this.player.currentTime(parseInt(index / 100 * this.video.maxTime))
    },
    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate(res) {
      this.video.currentTime = res.cache_.currentTime;
      this.sliderTime = this.video.currentTime / this.video.maxTime * 100
    },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onPlayerLoadeddata(res) {
      this.videoInfo.time = this.realFormatSecond(parseInt(res.cache_.duration));
      this.video.maxTime = parseInt(res.cache_.duration);
    },
    showSound () { //声音
      this.sound = !this.sound
      if (this.sound) {
        this.soundValue = 0
        this.player.cache_.lastVolume = this.soundValue / 100
        this.player.volume(this.player.cache_.lastVolume)
        this.soundOpacity = 0
      } else {
        // this.playerOptions.muted = false
        this.soundValue = this.newSoundValue
        this.player.cache_.lastVolume = this.soundValue / 100
        this.player.volume(this.player.cache_.lastVolume)
        this.soundOpacity = 1
        setTimeout(() => {
          this.soundOpacity = 0
        }, 3000);
      }
    },
    getChange () {
      this.sound = false
      this.newSoundValue = this.soundValue
      this.player.cache_.volume = this.newSoundValue / 100
      this.player.volume(this.player.cache_.volume)
    },
    // 获取当前日期节目单
    getDatePro (item, index) {
      this.proIndex = index
      this.newDate=this.program[index]
    },

    // 左按钮
    leftClick () {
      let boxWidth = document.getElementById("timeshift_scale_player").offsetWidth;
      
      // this.onPlayerPause()
      this.$refs.pointer.style.display = "none"
      if (this.step == 0) {
        this.step = 0
        this.$refs.epgPlayer.style.left = '0PX'
        this.$refs.scalePlayer.style.left = "0PX"
      } else {
        this.step++
        // this.$refs.epgPlayer.style.left = this.step * boxWidth + 'PX'
        this.$refs.scalePlayer.style.left = this.step * boxWidth + 'PX'
      }
    },
    // 右按钮
    rightClick () {
      // this.onPlayerPause()
      this.$refs.pointer.style.display = "none"
      // let epgboxWidth = this.$refs.epgWidth.clientWidth
      let maxWidth = this.$refs.scalePlayer.offsetWidth
      let boxWidth = document.getElementById("timeshift_scale_player").offsetWidth;
      let maxStep = parseInt(maxWidth/boxWidth)-1
      if (this.step == -maxStep) {
        // this.step = maxStep
        // this.$refs.epgPlayer.style.left = -parseInt(maxWidth) + parseInt(epgboxWidth) + 30 + 'PX'
        this.$refs.scalePlayer.style.left = -maxWidth + boxWidth + 'PX'
      } else {
        this.step--
        // this.$refs.epgPlayer.style.left = this.step * 800 + 'PX'
        this.$refs.scalePlayer.style.left = this.step * boxWidth + 'PX'
      }
    },
    // 节点拖动
    getPointer () {
      // this.onPlayerPause()
      // this.disNode()
      var that = this
      var box = document.querySelector(".date-scale");
      var videobox = document.querySelector(".video-box");
      var maxWith = box.clientWidth-15
      var left = box.offsetLeft + videobox.offsetLeft;
      let nodeLeft = that.$refs.scalePlayer.style.left||0 // 时间轴偏移
      document.getElementsByTagName('img')[0].onmousedown = function (e) {
        e.preventDefault()
      }
       box.onmousemove = function (e) {
        e.preventDefault()
        var bx = e.pageX - left - 10; // 节点偏移量
        let newNode = Math.abs(parseInt(that.newScalePlayer) - that.pointerLeft) + left // 当前节点
        let getNode = Math.abs(parseInt(nodeLeft) - e.pageX) // 拖拽节点到达的时间??
        if (newNode > getNode) {
          if (bx < 0) {
            that.$refs.pointer.style.left = -10 + 'PX';
          }else if (-10 < bx < maxWith){
            that.$refs.pointer.style.left = bx + 'PX';
          } 
          if (bx > maxWith) {
            that.$refs.pointer.style.left = maxWith + 'PX';
          }
        }
      }
      box.onmouseup = function () {
        box.onmousemove = box.onmouseup = null;
        let nodeLeft = that.$refs.scalePlayer.style.left||0
        let pointerLeft = that.$refs.pointer.style.left
        let PointerNode = parseInt(nodeLeft) - parseInt(pointerLeft) - 10 // 偏移长度
        let hours = parseInt(PointerNode / 10 / 60);
        let minutes = parseInt((PointerNode / 10) - (hours * 60));
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth() + 1;
        let dd = new Date().getDate();
        let timeCode = yy + '-' + mm + '-' + dd + ' ' + Math.abs(hours) + ':' + Math.abs(minutes) // 时间戳
        that.getUrl(that.urlId, Math.round(new Date(timeCode)))
        // that.createdNode()
        
        if (this.showShift) {
          clearInterval(that.urlTimer);
          that.urlTimer = null
          that.createdUrl()
        }
      }
    },
    // 节点定时器
    // createdNode () {
    //   let that = this
    //   this.disNode()
    //   let pointerLeft = parseInt(that.$refs.pointer.style.left)
    //   // let epgboxWidth = this.$refs.epgWidth.clientWidth
    //   that.timer = setInterval(function () {
    //     pointerLeft += (10 / 60)
    //     // if (pointerLeft > parseInt(epgboxWidth) + 120) {
    //     //   that.$refs.pointer.style.left = parseInt(epgboxWidth) + 100 + 'PX';
    //     // } else {
    //     //   that.$refs.pointer.style.left = pointerLeft + 'PX'
    //     // }
    //   }, 1000)
    // },
    // 销毁定时器
    // disNode () {
    //   clearInterval(this.timer);
    //   this.timer = null
    // },
    // 与后端定时交互 告知视频仍在运行
    createdUrl () {
      let that = this
      that.urlTimer = setInterval(function () {
        that.getHeartbeat(0)
      }, 6000 * 10)
    },
    getHeartbeat (item) {
      let obj = {
        state: item,
        userid: this.userid
      }
      axios.get('timeshift', { params: obj }).then(
        res => {
          if (res.data.result === -1) {
          } else {
          }
        })
    },
    // 获取当前节点url
    getUrl (id, time) {
      let obj = {
        begintime: time,
        id: id,
        userid: this.userid
      }
      clearInterval(this.urlTimer);
      this.urlTimer = null
      axios.get('timeshift', { params: obj }).then(
        res => {
          if (res.data.result === 0) {
            // res.data.message:当前播放流路径
            this.$nextTick(() => {
              let url = res.data.message
              var index = url.lastIndexOf(".");
              var ext = url.substr(index + 1);
              if(ext == 'm3u8') {
                this.playerOptions.sources[0].type = 'application/x-mpegURL'
              }else if(ext == 'flv') {
                this.playerOptions.sources[0].type = 'video/x-flv'
              }else if(ext == 'mov') {
                this.playerOptions.sources[0].type = 'rtmp/mp4'
              }else{
                this.playerOptions.sources[0].type = 'video/mp4'
              }
              this.playerOptions.sources[0].src = url + "?begintimeabs=" + time
              
              this.playerOptions.autoplay = false
              // this.getHeartbeat(0)
            })
            // this.createdNode()
            clearInterval(this.urlTimer);
            this.urlTimer = null
            this.createdUrl()
            }
        })
    },
    // 获取鼠标节点毫秒数
    getPointerNode (e) {
      // this.onPlayerPause()
      
      let nodeLeft = this.$refs.scalePlayer.style.left||0 // 时间偏移量
      var box = document.querySelector(".date-scale");
      var videobox = document.querySelector(".video-box");
      var left = box.offsetLeft + videobox.offsetLeft;
      var maxWith = box.clientWidth-15
      var bx = e.pageX - left;
      var newNode = Math.abs(parseInt(this.newScalePlayer) - this.pointerLeft) + left // 当前节点
      var getNode = Math.abs(parseInt(nodeLeft) - e.pageX) // 拖拽节点到达的时间??
      if (newNode > getNode) {
        this.$refs.pointer.style.display = "block" // 展示节点
        if (bx < 0) {
            this.$refs.pointer.style.left = -10 + 'PX';
          }else if (-10 < bx < maxWith){
            this.$refs.pointer.style.left = bx - 10 + 'PX';
          } 
          if (bx > maxWith) {
            this.$refs.pointer.style.left = maxWith + 'PX';
          }
          let pointerLeft = this.$refs.pointer.style.left
          let PointerNode = parseInt(nodeLeft) - parseInt(pointerLeft) - 10 // 偏移长度
          let hours = parseInt(PointerNode / 10 / 60); // 计算当前节点时间 小时 
          let minutes = parseInt((PointerNode / 10) - (hours * 60)); // 计算当前节点时间 分钟
          let yy = new Date().getFullYear();
          let mm = new Date().getMonth() + 1;
          let dd = new Date().getDate();
          let timeCode = yy + '-' + mm + '-' + dd + ' ' + Math.abs(hours) + ':' + Math.abs(minutes) // 时间戳
          this.getUrl(this.urlId, Math.round(new Date(timeCode)))
      }
      
      // }
    },
    // 秒转为时分秒
    formatSeconds(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime >= 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime >= 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var  result ="" + (parseInt(minuteTime) < 10? "0" + parseInt(minuteTime) : parseInt(minuteTime));
      result ="" + (parseInt(hourTime) < 10 ? "0" + parseInt(hourTime): parseInt(hourTime)) +":" + result;
      return result;
    },
    // 创建节点列表
    createTime(){
      this.timeNode=[]
      let listIndex = 60*60*24/600; // 一天共144个10分钟
      for (var i = 0; i < listIndex; i++) {
        let time = this.formatSeconds(i * 600)
        this.timeNode.push(time)
      }
    },
    forbidDefaultEvent(e){
      e.preventDefault();
    }
  },
  created () {
    this.urlId = this.passagewayId
    this.userid = JSON.parse(localStorage.getItem("user")).userId;
    this.createTime()
    //设置日期，当前日期的前七天
    var myDate = new Date(); //获取今天日期
    myDate.setDate(myDate.getDate() - 6);
    var dateTemp;
    var flag = 1;
    for (var i = 0; i < 7; i++) {
      dateTemp = (myDate.getMonth() + 1) + "-" + myDate.getDate();
      let obj = {
        date: dateTemp,
        round: Math.round(new Date(myDate.getFullYear() + "-" + dateTemp)),
        week: "周" + "日一二三四五六".charAt(new Date(myDate.getFullYear() + "-" + dateTemp).getDay())
      }
      this.program.push(obj);
      myDate.setDate(myDate.getDate() + flag);
    }
    this.newDate = this.program[6]
      // 禁止浏览器打开拖拽的图片
      document.addEventListener('drop', this.forbidDefaultEvent, false);
      document.addEventListener('dragover', this.forbidDefaultEvent, false);
  },
  beforeDestroy () {
    // this.getHeartbeat(2)
    // this.disNode()
    clearInterval(this.urlTimer);
    this.urlTimer = null
  },
  beforeRouteLeave (to, form, next) {
    // this.getHeartbeat(2)
    // this.disNode()
    clearInterval(this.urlTimer);
    this.urlTimer = null
    next()
  },
  destroyed () {
        document.removeEventListener('drop', this.forbidDefaultEvent, false);
        document.removeEventListener('dragover', this.forbidDefaultEvent, false);
  }
};
</script>
<style>
.ratio-popover{
  padding: 10PX 15PX;
  text-align: center;
  color: #fff;
  background: rgba(17,17,17,.7);
  border-radius: 8PX;
  border: 0PX;
}
.el-tooltip__popper.is-dark{
  display: none !important;
}
.time-shift .el-switch{
  height: 10PX;
  margin-right: 15PX;
}
.time-shift .el-switch__core{
   height: 10PX;
}
.time-shift .el-switch.is-checked .el-switch__core::after{
  margin-left: -8PX;
  left: 100%;
}
.time-shift .el-switch .el-switch__core::after{
  top: 0PX;
  left: 0PX;
  height: 8PX;
  width: 8PX;
}
</style>
<style lang="css" scoped>
.ali-player {
  width: 100%;
  height: 100%;
}
.ali-player >>> .vjs-big-play-button{
  display: none;
}
.ali-player >>> .vjs-error-display{
  display: none;
}
.ali-player >>> .video-js.vjs-fluid{
  height: 100%;
  padding:0PX;
}
.video-box,.video-player{
  width: 100%;
  height: 100%;
}
.shift-scaleLine{
  height: 56PX;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
}
.control-box{
  position: absolute;
  bottom: 0PX;
  left: 0PX;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.video-control{
  height: 56PX;
  display: flex;
  padding: 0 30PX;
  align-items: center;
  justify-content: space-between;
}
.control-left,.control-right{
  display: flex;
  align-items: center;
}
.video-sound{
  position: relative;
}
.video-sound .sound-slider{
  position: absolute;
  top: -130PX;
  left: 5PX;
  /* transform:rotate(-90deg); */
  opacity: 0;
  transition: all .5s linear .5s;
}
.video-sound:hover .video-sound .sound-slider{
  display: block;
  opacity: 1;
}
.video-sound img{
  width: 20PX;
  height: 20PX;
  display: block;
}
.video-sound .sound-slider:hover{
  display: block;
  opacity: 1;
}

#player_sound_btn_player{
  margin-left: 15PX;
  cursor: pointer;
  height: 20PX;
}
#player_sound_btn_player:hover + .sound-slider{
  display: block;
  opacity: 1;
}
.video-time{
  color: #fff;
  margin-left: 15PX;
  font-size: 12PX;
}
.video-progress {
  padding: 0 30PX;
  margin: 0 auto;
  margin-bottom: -10PX;
  position: relative;
}
.video-progress >>> .el-slider__runway{
  margin:10PX 0;
  height: 10PX;
}
.sound-slider >>> .el-slider__bar{
  background-color: #3A83FF !important;
  width: 10PX !important;
  margin-left: 0px;
}
.video-progress >>> .el-slider__bar{
  background-color: #3A83FF !important;
  height: 10PX;
}
.video-progress >>> .el-slider__button-wrapper{
  display: none;
  width: 10PX;
  height: 10PX;
  
}

.video-sound >>> .el-slider.is-vertical .el-slider__runway{
  width: 10PX !important;
}
.video-sound >>> .el-slider.is-vertical .el-slider__button-wrapper{
  width: 10PX;
  height: 10PX;
  left: -1px;
  margin-top: -2px;
}
.sound-slider >>> .el-slider__button{
  width: 10PX;
  height: 10PX;
  border: 1PX solid #409EFF;
  display: block;
  vertical-align: unset;
}
.pictureInPicture img,.full-screen img{
  cursor: pointer;
  display: block;
  width: 20PX;
  height: 20PX;
  margin-left: 20PX;
}
.news-ratio{
  color: #fff;
  font-size: 14PX;
  height: 20PX;
  line-height: 20PX;
}

.ratio-list li{
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 29PX;
  padding-right: 26PX;
  min-width: 99PX;
  position: relative;
  height: 34PX;
  line-height: 34PX;
  margin-top: 7PX;
  border-radius: 17PX;
  opacity: .8;
}
.ratio-list .is-active{
  color: #fff;
  background: hsla(0,0%,100%,.15);
  opacity: 1;
}
.time-shift .title{
  color: #fff;
  font-size: 14PX;
  margin-right: 10PX;
}
.date-select{
  width: 75PX;
  height: 100%;
  border-right: 1PX solid #8D8D8D;
  font-size: 12PX;
  font-weight: 500;
  color: #F3F3F3;
  line-height: 20PX;
  padding: 8PX 20PX 10PX 20PX;
  text-align: center;
  cursor: pointer;
}
#timeshift_pointer_player {
  position: absolute;
  bottom: 42PX;
  width: 20PX;
  height: 70PX;
  cursor: pointer;
  z-index: 12;
  display: block;
  transition: left 0s ease 0s;
}
.date-scale{
  width: calc(100% - 75PX);
  position: relative;
}
#timeshift_scale_player {
  height: 24PX;
  overflow: hidden;
  cursor: auto;
  width: 100%;
}
#timeshift_epg_player{
  border-top: 1PX solid #8D8D8D;
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: auto;
  width: 100%;
  height: 32PX;
  position: relative;
}
.epg-button{
  width: 30PX;
  height: 100%;
  line-height: 32PX;
  text-align: center;
}
.epg-program{
  width: calc(100% - 60PX);
  height: 100%;
  line-height: 32PX;
  text-align: center;
  overflow: hidden;
  position: relative;
}
#date_list_player {
  position: absolute;
  display: block;
  opacity: 0.9;
  padding: 0PX 10PX;
  text-align: center;
  font-size: 14PX;
  font-weight: bold;
  line-height: 37PX;
  bottom: 112PX;
  left: 12PX;
  color: #f3f3f3;
  z-index: 16;
  background-color: rgba(0, 0, 0, 0.5);
}
.program-list {
  cursor: pointer;
  color: #f3f3f3;
}
#date_list_player .is-active {
  color: #f09;
}

/* 左右按钮 */
/* .epg-player-btn {
  width: 12PX;
  height: 15PX;
  padding: 0PX;
  display: block;
  margin: auto;
} */
.second-epg {
  display: none;
}

.epg-right-button:hover .second-epg {
  display: inline-block;
}
.epg-right-button:hover .first-epg {
  display: none;
}
.epg-left-button:hover .second-epg {
  display: inline-block;
}
.epg-left-button:hover .first-epg {
  display: none;
}
.timeshift-scale-list{
  display: flex;
  align-items: center;
  height: 100%;
  width: calc(144 * 100PX);
  position: relative;
}
.scale-10-minute{
  width: 100PX;
  height: 100%;
  color: #f3f3f3;
  font-size: 10PX;
  border-right: 1PX solid #f3f3f3;
  position: relative;
  display: flex;
  align-items: flex-end;
}
.scale-1-minute{
  width: 20PX;
  height: 35%;
  color: #f3f3f3;
  border-right: 1PX solid #f3f3f3;
}
.scale-10-node{
  position: absolute;
  left: 5PX;
  top: 0PX;
}
#timeshift_pointer_player{
  position: absolute;
  left: -10PX;
  top: -13PX;
}
.video-control .video-btn{
  width: 22px;
}
</style>


